const SvgAnnotationsGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M10.751 8.734L8.03 11.473c-.173.174-.215.222-.372.625-.08.207-.23.83-.446 1.868A1.3 1.3 0 015.938 15H5a2 2 0 01-2-2V3a2 2 0 012-2h6a2 2 0 012 2v3.955a1.2 1.2 0 01-.95 1.173c-.59.127-1.023.328-1.299.606zm2.814.705a1.51 1.51 0 010 2.121l-2.717 2.735a.495.495 0 01-.218.128l-2.002.559a.491.491 0 01-.487-.133.503.503 0 01-.12-.494l.593-1.969a.501.501 0 01.125-.208l2.722-2.74a1.48 1.48 0 012.104 0zM5.5 4a.5.5 0 000 1h5a.5.5 0 100-1h-5zm0 2a.5.5 0 000 1h3a.5.5 0 000-1h-3z' />
  </svg>
);

export default SvgAnnotationsGlyph;
